import React, { useState, useEffect, Fragment } from "react";
import { Layout, Grid } from "antd";
import "./FullLayout.css";
import Sidebar from "./Sidebar";
import { Link, Redirect } from "react-router-dom";
import Navbar from "./Navbar";

const { Header, Footer, Sider } = Layout;
const { useBreakpoint } = Grid;

function FullLayout(props) {
  const [collapsed, setCollapsed] = useState(false);
  const screens = useBreakpoint();

  // const permissions = sessionStorage.getItem("permissions")
  //   ? JSON.parse(sessionStorage.getItem("permissions")).filter(
  //     (permission) => permission !== null
  //     )
  //   : [];
  const handleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    const width = window.innerWidth;
    width <= 500 && setCollapsed(false);
  }, []);

  const refresh = () => {
    const path = props.history.location.pathname;
    window.location = path;
  };

  const activePath = props.history.location.pathname;

  return sessionStorage.getItem("token") ? (
    <Layout className="body">
      <Sider
        breakpoint="lg"
        onBreakpoint={(broken) => {
          setCollapsed(broken);
        }}
        trigger={null}
        collapsed={collapsed}>
        <Sidebar {...props} collapsed={collapsed} />
      </Sider>
      <Layout>
        <Navbar
          {...props}
          refresh={refresh}
          collapsed={collapsed}
          screens={screens}
          onToggleCollapsed={handleCollapsed}
        />
        <div className="app-content content ">
          <div className="content-overlay"></div>
          <div className="header-navbar-shadow"></div>
          <div className="content-wrapper container-xxl p-0">
            <div className="content-header row">
              <div className="content-header-left col-md-9 col-12 mb-2">
                <div className="row breadcrumbs-top">
                  <div className="col-12">
                    <h2 className="content-header-title float-left mb-0">
                      SSO
                    </h2>
                    <div className="breadcrumb-wrapper">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link
                            to={`/${activePath.split("/")[1]}`}
                            className="d-flex align-items-center">
                            Back
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          {activePath === props.location.pathname
                            ? props.location.pathname.split("/")[1]
                            : "/"}
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="content-body">
              <section id="backcolor">
                <div className="row">
                  <div className="col-12">
                    <Fragment>{props.children}</Fragment>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <div className="sidenav-overlay"></div>
        <div className="drag-target"></div>

        <footer className="footer footer-static footer-light">
          <p className="clearfix mb-0">
            <span className="float-md-left d-block d-md-inline-block mt-25">
              COPYRIGHT &copy; 2024
              <a className="ml-25" href="javascript:void(0)" rel="noreferrer">
                PT. DHARMA POLIMETAL Tbk
              </a>
              <span className="d-none d-sm-inline-block">
                , All rights Reserved
              </span>
            </span>
          </p>
        </footer>
      </Layout>
    </Layout>
  ) : (
    <Redirect to="/login" />
  );
}

export default FullLayout;
